import { generatePath } from 'react-router-dom';
import { authSwitchRoutes } from '@isyc-react/auth/modules/base';
export const switchRoutes = Object.assign(Object.assign({}, authSwitchRoutes), { root: '/', bu: '/bu/:code', courses: '/courses', error: '/error' });
export const routes = Object.assign(Object.assign({}, switchRoutes), { bu: code => generatePath(switchRoutes.bu, { code }) });
